import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { getIncompletePaymentCheque } from 'apps/auth/actions/historyAction';
import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { PanelContent, PanelFrame, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { DiskBadgeWrapper } from 'apps/auth/components/paysendPlus/styles';
import { AWAITING_TRANSFER_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AMOUNT, AWAITING_STATUS } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { RESUME } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { CATEGORY_TRANSFER_TO_CASH, CATEGORY_TRANSFER_TO_CASH_UNITELLER, CATEGORY_TRANSFER_TO_HOME_DELIVERY } from 'apps/auth/constants/Constants';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import { getIconForDiskBadge, getToAccount } from 'apps/auth/helpers/historyUtils';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import IncompletePaymentCheque from './IncompletePaymentCheque';
import { TransactionsBlockSubheader, TransactionsFeedHeader, TransactionsHistoryList } from '../styles';

const IncompletePaymentInfo = (props) => {
    const messages = usePageMessages();

    const showDetails = (e) => {
        e.preventDefault();
        props
            .getIncompletePaymentCheque()
            .then(() => {
                props.modalRef.current?.open(<IncompletePaymentCheque popupRef={props.popupRef} modalRef={props.modalRef} />);
            })
            .catch((error) => {
                logWarn(error);
                return null;
            });
    };

    const getAmount = (recordForAmount) => {
        const currencyCode =
            recordForAmount.amountToCurrency && typeof recordForAmount.amountToCurrency === 'string' ? recordForAmount.amountToCurrency.toLowerCase() : '';
        return (
            <Text variant="div" color={'secondary'} ellipsis>
                {`-${recordForAmount.amountTo} `}
                <Text color={'secondary'} smallCaps>
                    {currencyCode}
                </Text>
            </Text>
        );
    };

    const getTitle = (recordForTitle) => {
        let account =
            recordForTitle.providerToCategory === CATEGORY_TRANSFER_TO_CASH || recordForTitle.providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY
                ? ''
                : recordForTitle.accountTo;
        if (recordForTitle.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER) {
            account = recordForTitle.toAccountBankName;
        }
        return (
            <Text size="secondary" color={'secondary'} ellipsis>
                {getToAccount(recordForTitle.providerToCategory, recordForTitle?.toCountryId, account, messages)}
            </Text>
        );
    };

    const record = props.record;

    return (
        <TransactionsHistoryList isNewMainScreen={props.isNewMainScreen}>
            <li>
                <TransactionsBlockSubheader isNewMainScreen={props.isNewMainScreen}>
                    <Text variant="div" color="secondary" size="subheader">
                        {messages.awaitingBlock}
                    </Text>
                </TransactionsBlockSubheader>
                <TransactionsFeedHeader
                    isNewMainScreen={props.isNewMainScreen}
                    onClick={(e) => {
                        amplitude.getInstance().logEvent(AWAITING_TRANSFER_CLICKED, {
                            [AMOUNT]: record.amountTo,
                            [AWAITING_STATUS]: RESUME,
                        });
                        showDetails(e);
                    }}
                >
                    <PanelFrame>
                        <DiskBadgeWrapper>
                            <DiskBadge
                                iconName={getIconForDiskBadge(record, record.providerToCategory, record.transactionType)}
                                variant={'tertiary'}
                                isDisabled={false}
                                flagName={toLowerCase(record?.toCountry?.code)}
                            />
                        </DiskBadgeWrapper>
                        <PanelContent>
                            <PanelRow>
                                <Text color={'primary'} ellipsis>
                                    {record.toProviderName === '' ? messages.transferDefaultTitle : record.toProviderName}
                                </Text>
                            </PanelRow>
                            <PanelRow>
                                <Text size={'secondary'} color={'lightGray'} ellipsis>
                                    {getTitle(record)}
                                </Text>
                            </PanelRow>
                        </PanelContent>
                        <PanelRightBlock>
                            {record.amountTo && <PanelRow>{getAmount(record)}</PanelRow>}
                            <PanelRow alignEnd>
                                <Badge caption={messages.resumeTransferLabel} />
                            </PanelRow>
                        </PanelRightBlock>
                    </PanelFrame>
                </TransactionsFeedHeader>
            </li>
        </TransactionsHistoryList>
    );
};

export default connect(null, { getIncompletePaymentCheque })(IncompletePaymentInfo);
